import { useState, useCallback } from "react";

export function useMultiSelect<T>() {
    const [selectedItems, setSelectedItems] = useState<T[]>([]);
    const [allItemsSelected, setAllItemsSelected] = useState<boolean>(false);

    const handleMultiSelect = useCallback(
        (selected: boolean, itemIds: T[]) =>
            selected
                ? setSelectedItems([...selectedItems, ...itemIds])
                : setSelectedItems(
                      selectedItems.filter(i => !itemIds.includes(i))
                  ),
        [selectedItems]
    );

    return {
        selectedItems,
        setSelectedItems,
        handleMultiSelect,
        allItemsSelected,
        setAllItemsSelected,
    };
}
